import { actionTypes } from "redux-firestore";

const initState = {
  adminView: false
}

const userReducer = (state = initState, action) => {
  switch (action.type) {
    
    case 'USERS_RETRIEVED':
      console.log('users retrieved');
      return {
        ...state,
        users: action.users
      }
    case 'PROJECT_CHANGED':
      return {
        ...state,
        users: null
      }  
      case 'ADMIN_VIEW_SET':
      return {
        ...state,
        adminView: action.adminView
      }  
    default:
      return state;
  }
};

export default userReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/userReducer.js